<template>
    <FormModal
        :visible="showModalCreate"
        :title="titulo || 'Perfil do Investidor'"
        :show-cancel="false"
        confirm-label="Entendi"
        @update:visible="closeModal"
        @confirm="closeModal"
    >
        <template #icon>
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-100 dark:bg-blue-900/30">
                <i class="fa fa-question-circle text-blue-600 dark:text-blue-400 text-2xl"></i>
            </div>
        </template>

        <div class="text-center">
            <div v-if="conteudo" class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed" v-html="conteudo"></div>
            <p v-else class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                O perfil de investidor é o resultado de uma análise das suas características em relação a investimentos, e principalmente ao risco envolvido. Simples de ser descoberto através de algumas questões, o perfil de investidor serve para indicar a carteira de investimentos mais adequada para você.
            </p>
        </div>
    </FormModal>
</template>

<script>
import { mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";

export default {
    components: {
        FormModal
    },
    props: {
        conteudo: {
            type: String,
            default: null
        },
        titulo: {
            type: String,
            default: null
        }
    },
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_SAIBA_MAIS_INFORMATIVO",
            user: 'auth/user',
        }),
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_SAIBA_MAIS_INFORMATIVO", false);
        },
    },
};
</script>

<style scoped>
/* Estilos mínimos - FormModal gerencia a estrutura */
</style>
